(() => {
  if (window.__ysEventPageLoaded) return; window.__ysCampaignLoaded = true;
  function setup(root) {
    root.querySelectorAll('[data-ys-countdown]').forEach(el => {
      const raw = el.dataset.ysCountdown;
      if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(raw)) return;
      const end = Date.parse(raw); if (!Number.isFinite(end)) return;
      const tick = () => { const s = Math.floor((end-Date.now())/1000); el.hidden = s <= 0; if (s <= 0) { clearInterval(timer); return; } const parts=[[Math.floor(s/86400),'DAYS'],[Math.floor(s/3600)%24,'HOURS'],[Math.floor(s/60)%60,'MINS'],[s%60,'SECS']];el.querySelector('[data-ys-countdown-value]').innerHTML=parts.map(([value,label])=>`<span><b>${String(value).padStart(2,'0')}</b><small>${label}</small></span>`).join(''); };
      const timer = setInterval(() => { if (!el.isConnected) clearInterval(timer); else tick(); },1000); tick();
    });
    const tabs = [...root.querySelectorAll('[data-ys-tab]')];
    function select(tab) { tabs.forEach(t => { const on=t===tab; t.setAttribute('aria-selected',String(on)); t.tabIndex=on?0:-1; }); root.querySelectorAll('[data-ys-tab-panel]').forEach(p=>p.hidden=p.dataset.ysTabPanel!==tab.dataset.ysTab); }
    tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',e=>{if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;e.preventDefault();const next=tabs[e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length];select(next);next.focus();});});
    root.querySelectorAll('[data-ys-video]').forEach(button=>{
      let u;try {u=new URL(button.dataset.ysVideo);}catch{return;}
      if (!['youtube.com','www.youtube.com','youtu.be'].includes(u.hostname)) return;
      const id=u.hostname==='youtu.be'?u.pathname.slice(1):u.pathname.startsWith('/embed/')?u.pathname.split('/')[2]:u.searchParams.get('v');
      if (!/^[\w-]{11}$/.test(id||'')) return;
      const cover=button.querySelector('[data-ys-video-cover]');if(cover)cover.src=`https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
      button.addEventListener('click',()=>{const frame=document.createElement('iframe');frame.src=`https://www.youtube-nocookie.com/embed/${id}?autoplay=1`;frame.title=button.getAttribute('aria-label');frame.allow='autoplay; encrypted-media; picture-in-picture';frame.allowFullscreen=true;frame.style.cssText='width:100%;aspect-ratio:16/9;border:0';button.replaceWith(frame);},{once:true});
    });
  }
  async function home(el) {
    if (el.dataset.initialized) return; el.dataset.initialized='true';
    const existing=document.querySelector('[id$="__infinite_scroll_hero_Ug7KkN"]') || document.querySelector('.hero-section')?.closest('.shopify-section');
    if (!existing || existing.contains(el)) return;
    try {
      const url=new URL(el.dataset.pageUrl,location.origin);if(url.origin!==location.origin)return;
      const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
      const response=await fetch(url,{signal:AbortSignal.timeout(12000)});if(!response.ok)return;
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');const page=doc.querySelector('[data-ys-campaign-page][data-home-enabled="true"]');const hero=page?.querySelector('[data-ys-campaign-hero]');if(!hero || !el.isConnected)return;
      const copy=hero.cloneNode(true);copy.querySelectorAll('[id]').forEach(n=>n.id+='-home');copy.setAttribute('aria-labelledby',copy.querySelector('h1').id);
      copy.querySelectorAll('[data-ys-home-link]').forEach(a=>{const isSecondary=a.dataset.ysHomeTarget==='categories';const label=isSecondary?el.dataset.homeSecondaryLabel:el.dataset.homePrimaryLabel;const icon=a.querySelector('[aria-hidden="true"]');if(label&&icon){a.textContent=label+' ';a.append(icon);}if(isSecondary&&el.dataset.homeSecondaryUrl){a.href=new URL(el.dataset.homeSecondaryUrl,location.origin).href;}else{a.href=url.href;}});
      const marker=document.createComment('Original daily hero position');existing.before(marker);
      el.classList.add('ys-campaign');el.hidden=false;
      const track=document.createElement('div');track.className='ys-campaign-home__track';track.setAttribute('aria-label','Homepage banners');
      const slideNodes=el.dataset.firstSlide==='original'?[existing,copy]:[copy,existing];
      const panels=slideNodes.map(node=>{const p=document.createElement('div');p.className='ys-campaign-home__panel';p.dataset.slideType=node===copy?'campaign':'original';p.append(node);track.append(p);return p;});el.append(track);
      const nav=document.createElement('div');nav.className='ys-campaign-home__nav';nav.hidden=el.dataset.showControls==='false';el.append(nav);
      let active=0,paused=el.dataset.autoplayEnabled==='false'||matchMedia('(prefers-reduced-motion: reduce)').matches,hover=false,inView=true;
      function button(label,text,fn){const b=document.createElement('button');b.type='button';b.setAttribute('aria-label',label);b.textContent=text;b.addEventListener('click',fn);nav.append(b);return b;}
      function go(n){active=(n+2)%2;track.scrollTo({left:active*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});update();}
      const previous=button('Previous banner','‹',()=>go(active-1));previous.className='ys-campaign-home__arrow';
      const dots=[0,1].map(i=>{const campaignFirst=el.dataset.firstSlide!=='original';const isCampaign=campaignFirst?i===0:i===1;const dot=button(isCampaign?'Black Friday banner':'Original banner','',()=>go(i));dot.className='ys-campaign-home__dot';return dot;});
      const next=button('Next banner','›',()=>go(active+1));next.className='ys-campaign-home__arrow';
      const pause=button(paused?'Play automatic banners':'Pause automatic banners',paused?'▶':'Ⅱ',()=>{paused=!paused;pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?'Play automatic banners':'Pause automatic banners');});pause.className='ys-campaign-home__pause';
      function update(){panels.forEach((p,i)=>{p.inert=i!==active;p.setAttribute('aria-hidden',String(i!==active));dots[i].setAttribute('aria-current',String(i===active));});el.dataset.activeSlide=panels[active].dataset.slideType;track.style.height=panels[active].scrollHeight+'px';}
      let raf;track.addEventListener('scroll',()=>{cancelAnimationFrame(raf);raf=requestAnimationFrame(()=>{active=Math.round(track.scrollLeft/Math.max(1,track.clientWidth));active=Math.min(1,Math.max(0,active));update();});});
      let dragStartX=0,dragStartScroll=0,dragging=false,dragMoved=false;
      track.addEventListener('pointerdown',event=>{if(event.pointerType==='touch'||event.button!==0||event.target.closest('a,button,input,select,textarea,label'))return;dragStartX=event.clientX;dragStartScroll=track.scrollLeft;dragging=true;dragMoved=false;track.classList.add('is-dragging');track.setPointerCapture(event.pointerId);});
      track.addEventListener('pointermove',event=>{if(!dragging)return;const distance=event.clientX-dragStartX;if(Math.abs(distance)>5)dragMoved=true;if(dragMoved){event.preventDefault();track.scrollLeft=dragStartScroll-distance;}});
      const endDrag=event=>{if(!dragging)return;dragging=false;track.classList.remove('is-dragging');if(track.hasPointerCapture(event.pointerId))track.releasePointerCapture(event.pointerId);go(Math.round(track.scrollLeft/Math.max(1,track.clientWidth)));};
      track.addEventListener('pointerup',endDrag);track.addEventListener('pointercancel',endDrag);
      track.addEventListener('click',event=>{if(dragMoved){event.preventDefault();event.stopPropagation();dragMoved=false;}},true);
      el.addEventListener('mouseenter',()=>hover=true);el.addEventListener('mouseleave',()=>hover=false);
      const resize=new ResizeObserver(update);panels.forEach(p=>resize.observe(p));
      const observer=new IntersectionObserver(entries=>inView=entries[0].isIntersecting);observer.observe(el);
      const timer=setInterval(()=>{if(!el.isConnected){clearInterval(timer);resize.disconnect();observer.disconnect();if(marker.isConnected){marker.replaceWith(existing);}return;}if(!paused&&!hover&&inView&&!document.hidden&&!el.contains(document.activeElement))go(active+1);},Math.max(5,Number(el.dataset.autoplaySeconds)||7)*1000);
      setup(copy);update();
    } catch(error) { console.info('Campaign banner unavailable; original banner retained.'); }
  }
  function init(scope=document){scope.querySelectorAll('[data-ys-campaign-page]').forEach(setup);scope.querySelectorAll('[data-ys-campaign-home]').forEach(home);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();

/*
  Paste this entire block at the very end of assets/yes-event-page.js.
  Do not replace page.cyber-monday.json.
*/

/* Cyber Monday: on the full event page, jump the secondary hero CTA to products.
   The homepage clone is intentionally excluded, so it keeps linking to the event page. */
(() => {
  const bindProductJump = (scope = document) => {
scope.querySelectorAll('[data-ys-campaign-page]').forEach(page => {
const button = page.querySelector('.ys-campaign-hero .ys-campaign-text-link');
const products = page.querySelector('.ys-campaign-shop');

const isCyberMonday =
  page.classList.contains('ys-event--data-stream');

const isBlackFriday =
  location.pathname.replace(/\/+$/, '') ===
    '/pages/yesimilar-black-friday-sale' &&
  button?.getAttribute('href') === '#campaign-products';

if (!isCyberMonday && !isBlackFriday) return;
if (!button || !products || button.dataset.ysProductJumpBound === 'true') return;

      products.id = products.id || 'ys-event-products';
      button.href = `#${products.id}`;
      button.dataset.ysProductJumpBound = 'true';

      button.addEventListener('click', event => {
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) return;

        event.preventDefault();

        const reducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        const headerOffset = 84;
        const top =
          products.getBoundingClientRect().top +
          window.scrollY -
          headerOffset;

        window.scrollTo({
          top: Math.max(0, top),
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => bindProductJump(),
      { once: true }
    );
  } else {
    bindProductJump();
  }

  document.addEventListener(
    'shopify:section:load',
    event => bindProductJump(event.target)
  );
})();
